import React from 'react';
import { useTabsContext } from './TabsContextProvider';

interface IProps {
  tabId: string | number | symbol,
  className?: string,
  dataTest?: string,
  selected?: boolean,
  component?: React.ElementType,
  children?: React.ReactNode,
}
const TabPanel = ({
  tabId,
  className,
  dataTest,
  selected = false,
  component: Component,
  children,
}: IProps) => {
  const context = useTabsContext();
  const isSelected = context?.isSelected(tabId) ?? selected;

  return (
    <div
      className={ className }
      data-test={ dataTest }
      id={ tabId.toString() }
      role="tabpanel"
      hidden={ !isSelected }
    >
      { Component ? (
        <Component selected={ isSelected }>
          { children }
        </Component>
      ) : children }
    </div>
  );
};

export default TabPanel;
